import { render, staticRenderFns } from "./ActionChooseBox.vue?vue&type=template&id=efc333f8&scoped=true&"
import script from "./ActionChooseBox.vue?vue&type=script&lang=js&"
export * from "./ActionChooseBox.vue?vue&type=script&lang=js&"
import style0 from "./ActionChooseBox.vue?vue&type=style&index=0&id=efc333f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../steam-app-cms-prod/steam-app-cms/sources/client/fastboot-cms-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc333f8",
  null
  
)

export default component.exports